import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TabContextService } from '@modules/auth/services/tab-context.service';

@Injectable()
export class delegatorAgencyInterceptor implements HttpInterceptor {
  constructor(private tabCtx: TabContextService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.url.includes('/auth')) {
      return next.handle(request);
    }

    const agency = this.tabCtx.getAgency();
    let user: any = null;
    try {
      const rawUser = localStorage.getItem('user');
      user = rawUser ? JSON.parse(rawUser) : null;
    } catch {
      user = null;
    }
    const delegatorAgencyId = agency?.agencyId ?? user?.agency?.agencyId;

    const clonedRequest = delegatorAgencyId
      ? request.clone({
          setHeaders: {
            'x-delegatorAgencyId': delegatorAgencyId,
          },
        })
      : request;
    return next.handle(clonedRequest);
  }
}
